import type { GraphPluginConstructor } from '@maxgraph/core';
import {
  SelectionHandler,
  SelectionCellsHandler,
  RubberBandHandler,
  PanningHandler,
  TooltipHandler,
  PopupMenuHandler,
  ConnectionHandler,
  KeyHandler,
  CellEditorHandler,
} from '@maxgraph/core';

export function getPluginList(): GraphPluginConstructor[] {
  // KeyHandler does not implement the GraphPlugin interface in maxGraph 0.15.x
  // (it has no static pluginId), so it is cast to satisfy the plugin list type.
  // Keyboard bindings are wired after construction in a later phase.
  return [
    SelectionHandler,
    SelectionCellsHandler,
    RubberBandHandler,
    PanningHandler,
    TooltipHandler,
    PopupMenuHandler,
    ConnectionHandler,
    KeyHandler as unknown as GraphPluginConstructor,
    CellEditorHandler,
  ];
}
